import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { AdminDataProvider } from './contexts/AdminDataContext';
render(<AdminDataProvider data-id="element-1819">
    <AppRouter data-id="element-1820" />
  </AdminDataProvider>, document.getElementById('root'));